/* accordions
 ========================================================================== */

import { initAccordions, setAutoHeights } from './lib';

export default function addAccordions() {
    // init accordions based on data components
    initAccordions();
    // set auto heights
    setAutoHeights();
}
